import d3 from 'd3';
import swoopyArrow from './swoopy';
import select from './select';
import selectAll from './select-all';

export default class Minimaps {
  constructor({ resizeObserver }) {
    this.el = select('.minimap-container');
    this.elContainers = selectAll('.minimap-mapimg-container');
    this.resizeObserver = resizeObserver;
  }

  init() {
    this.resizeObserver.add(() => {
      d3.selectAll('.minimap-mapimg-container svg').remove();

      this.elContainers.forEach((el, idx) => {
        this.makeSwoopy(el, idx);
      });
    });

    this.elContainers.forEach((el, idx) => {
      const img = select('img', el);

      if (img.src && img.complete) {
        this.makeSwoopy(el, idx);
      } else {
        const onImageLoad = () => {
          this.makeSwoopy(el, idx);
          img.removeEventListener('load', onImageLoad, false);
        };

        img.addEventListener('load', onImageLoad, false);
      }
    });
  }

  makeSwoopy(el, idx = 0) {
    const w = 400;
    const h = 400;
    const bounds = el.getBoundingClientRect();
    const curWidth = bounds.width;
    const curHeight = bounds.height;

    const datumW = function(it) {
      return curWidth * (it / w);
    };

    const datumH = function(it) {
      return curHeight * (it / h);
    };

    const swoopy = swoopyArrow()
      .angle(Math.PI / 4)
      .x(d => d[0])
      .y(d => d[1]);

    const swoopycounter = swoopyArrow()
      .angle(Math.PI / 4)
      .clockwise(false)
      .x(d => d[0])
      .y(d => d[1]);

    const straightLine = d3.svg
      .line()
      .x(function(d) {
        return d.x;
      })
      .y(function(d) {
        return d.y;
      })
      .interpolate('linear');

    // Set up container
    const svg = d3
      .select(el)
      .append('svg')
      .attr('xmlns', 'http://www.w3.org/2000/svg')
      .classed('minimap-arrow-container', true);

    svg
      .append('defs')
      .append('marker')
      .attr('id', 'arrowhead2')
      .attr('viewBox', '-10 -10 20 20')
      .attr('refX', 0)
      .attr('refY', 0)
      .attr('markerWidth', 20)
      .attr('markerHeight', 20)
      .attr('orient', 'auto')
      .append('polyline')
      .attr('stroke-linejoin', 'bevel')
      .attr('points', '-6.75,-6.75 0,0 -6.75,6.75')
      .attr('fill', '#fff');

    // make the scale bars
    let scaleLine;
    if (window.innerWidth > 320) {
      scaleLine = [
        { x: datumW(5), y: datumH(382) },
        { x: datumW(80), y: datumH(382) },
      ];
    } else {
      scaleLine = [
        { x: datumW(5), y: datumH(375) },
        { x: datumW(80), y: datumH(375) },
      ];
    }
    svg
      .append('path')
      .attr('stroke', '#fff')
      .attr('fill', 'transparent')
      .attr('class', 'scalebar')
      .attr('stroke-width', 2)
      .attr('d', straightLine(scaleLine));

    if (idx < 2) {
      // twin lakes
      svg
        .append('path')
        .attr('class', 'arrow')
        .attr('marker-end', 'url(#arrowhead2)')
        .attr('stroke', '#fff')
        .attr('stroke-width', 1)
        .attr('fill', 'transparent')
        .datum([[datumW(220), datumH(30)], [datumW(220), datumH(85)]])
        .attr('d', swoopy);

      const labelLine = [
        { x: datumW(105), y: datumH(230) },
        { x: datumW(140), y: datumH(210) },
      ];
      svg
        .append('path')
        .attr('stroke', '#fff')
        .attr('fill', 'transparent')
        .attr('class', 'subdiv-miniline')
        .attr('d', straightLine(labelLine));
    } else if (idx < 4) {
      // lakes on eldridge
      svg
        .append('path')
        .attr('class', 'arrow')
        .attr('marker-end', 'url(#arrowhead2)')
        .attr('stroke', '#fff')
        .attr('stroke-width', 1)
        .attr('fill', 'transparent')
        .datum([[datumW(155), datumH(33)], [datumW(128), datumH(85)]])
        .attr('d', swoopy);

      const labelLine = [
        { x: datumW(40), y: datumH(280) },
        { x: datumW(100), y: datumH(210) },
      ];
      svg
        .append('path')
        .attr('stroke', '#fff')
        .attr('fill', 'transparent')
        .attr('class', 'subdiv-miniline')
        .attr('d', straightLine(labelLine));
    } else if (idx < 6) {
      svg
        .append('path')
        .attr('class', 'arrow')
        .attr('marker-end', 'url(#arrowhead2)')
        .attr('stroke', '#fff')
        .attr('stroke-width', 1)
        .attr('fill', 'transparent')
        .datum([[datumW(20), datumH(77)], [datumW(65), datumH(140)]])
        .attr('d', swoopycounter);

      const labelLine = [
        { x: datumW(300), y: datumH(235) },
        { x: datumW(249), y: datumH(212) },
      ];
      svg
        .append('path')
        .attr('stroke', '#fff')
        .attr('fill', 'transparent')
        .attr('class', 'subdiv-miniline')
        .attr('d', straightLine(labelLine));
    }
  }
}



// WEBPACK FOOTER //
// ./utils/minimaps.js